// extracted by mini-css-extract-plugin
export default {"paraList":"FetchBlog_paraList__P3EUl","div":"FetchBlog_div__xN4Gn","textDiv":"FetchBlog_textDiv__T-6xt","imgDiv":"FetchBlog_imgDiv__+0uKn"};